import { FormLabel } from '@mui/material';
import styled from 'styled-components';

import { TStyledFormLabelProps } from '@/shared/components/ui/form/components/form-label/form-label.types';

export const Label = styled(FormLabel)<TStyledFormLabelProps>`
  && {
    margin-bottom: ${({ $gutterBottom }) => ($gutterBottom ? '0.75rem' : '0')};
    color: ${({ theme, $isFocused }) =>
      $isFocused ? theme.palette.primary.main : theme.palette.text.primary};
    ${({ theme }) => theme.typography.button2};

    &.Mui-error {
      color: ${({ theme }) => theme.palette.status.red.text};
    }
  }
`;

export const Optional = styled.span`
  margin-left: 0.375rem;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
